import { useState, useEffect, useRef } from "react";
import axios from 'axios';

export const useRequest = (url) => {

    const isMounted = useRef(true);

    const [state, setState] = useState({ data: null, loading: true, error: null });

    useEffect(() => {
        return () => {
            isMounted.current = false;
        }
    }, [])

    useEffect(() => {

        setState({ data: null, loading: true, error: null })

        axios.get(url)
            .then((res) => {
                setTimeout(() => {
                    if (isMounted.current) {
                        setState({
                            loading: false,
                            error: null,
                            data: res.data
                        })
                    }
                }, 10);
            }).catch((err) => {
                setState({
                    loading: false,
                    error: err,
                    data: null
                })
            })
    }, [url]);

    return state;
}
